import { useAccount, useReadContract } from "wagmi";
import useDappConfig from "./useDappConfig";
import { formatEther } from "viem";
import useExchangeRate from "./useExchangeRate";
import { MINT_LIMIT_CHAINS } from "@constants/chains";

const useMintLimit = () => {
  const { config } = useDappConfig();
  const { exchangeRate } = useExchangeRate();
  const { chainId } = useAccount();

  const { data, isLoading, isError, error } = useReadContract({
    ...config.interactionPools.lrtDepositPool,
    functionName: "remainingDailyMintLimit",

    query: {
      enabled: !!chainId && MINT_LIMIT_CHAINS.includes(chainId),
      refetchInterval: 60_000,
    },
  });

  if (isLoading || !chainId || !MINT_LIMIT_CHAINS.includes(chainId)) {
    return {
      remainingLimit: null,
      remainingLimitRsEth: null,
      isLoading: isLoading,
      isError: null,
    };
  }

  try {
    if (!data || isError) {
      throw new Error(error?.message || "Data not found");
    }

    const rsEthMintLimit = (data || 0n) as bigint;

    const remainingLimit = Number(rsEthMintLimit) * (exchangeRate || 1);
    const formattedValue = Number(formatEther(BigInt(remainingLimit))).toFixed(
      2
    );
    const formattedValueRsEth = Number(
      formatEther((rsEthMintLimit as bigint) || 0n)
    ).toFixed(2);

    return {
      remainingLimit: formattedValue,
      remainingLimitRsEth: formattedValueRsEth,
      isLoading,
      isError: null,
    };
  } catch (error) {
    console.log("Error fetching mint limit", error);
    return {
      remainingLimit: null,
      remainingLimitRsEth: null,
      isLoading: false,
      isError: true,
    };
  }
};

export default useMintLimit;
